// extracted by mini-css-extract-plugin
var _1 = "ColumnTitle_active__4feec";
var _2 = "ColumnTitle_asc__fa205";
var _3 = "ColumnTitle_icon__a2633";
var _4 = "ColumnTitle_right__7d9cc";
var _5 = "ColumnTitle_root__85c3b";
var _6 = "ColumnTitle_sortable__adc91";
var _7 = "ColumnTitle_text__14c24";
var _8 = "ColumnTitle_title__cff57";
export { _1 as "active", _2 as "asc", _3 as "icon", _4 as "right", _5 as "root", _6 as "sortable", _7 as "text", _8 as "title" }
